<template>
   <div v-if="finishedLoading">
        <div class="d-flex justify-content-center align-items-center dashboard" style="display: none !important;">
            <div class="dashboard__complete">
                <div class="row">
                    <div class="col-12 text-center">
                        <h1>Em Construção</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <!-- PERFIL - NOTIFICAÇÕES  -->
            <section class="no-space">
                <div class="tit">
                    <h2>
                       Configurações
                    </h2>
                    <p>
                        <!-- Selecione abaixo as notificações que deseja receber da IOUU -->
                        Selecione abaixo as configurações do seu perfil na IOUU
                    </p>
                </div>
            </section>


                        <!-- NOTIFICAÇÕES POR EMAIL -->
            <!-- <section class="small-space">
                <h3>
                    Saque
                </h3>
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                               
                                <span class="big">
                                    Saque automático 
                                      <at-popover trigger="hover" placement="right" content="Caso selecione a opção SIM, toda vez que você receber um repagamento, será feito uma transferência automática para a conta bancária cadastrada.">
                                            <i class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Sim
                                        <input  class="form-check-input" type="radio" id="SaqueAutomaticoTrue" value="true" v-model="SaqueAutomatico">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não
                                        <input  class="form-check-input" type="radio" id="SaqueAutomaticoFalse" value="false" v-model="SaqueAutomatico">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                   
                </div>
            </section> -->
            <!-- :::::::::::::::::::: -->

            <!-- NOTIFICAÇÕES POR EMAIL -->
            <section class="small-space">
                <h3>
                    Notificações por e-mail
                </h3>
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    investidor
                                </label>
                                <span class="big">
                                    Aviso de novas oportunidades
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input ref="EmailOportunidades" class="form-check-input" type="radio" id="OportunidadesTrue" value="true" v-model="EmailOportunidades">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input ref="EmailOportunidades" class="form-check-input" type="radio" id="OportunidadesFalse" value="false" v-model="EmailOportunidades">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    Repagamento
                                </label>
                                <span class="big">
                                    Notificação de repagamentos dos investimentos
                                </span>
                                <div class="form-check form-check-inline">
                                <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="EmailRepagamentoTrue" value="true" v-model="EmailRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="EmailRepagamentoFalse" value="false" v-model="EmailRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    Newsletter
                                </label>
                                <span class="big">
                                    Resumo mensal com novidades, notícias, material, etc
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="EmailNewsletterTrue" value="true" v-model="EmailNewsletter">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="EmailNewsletterFalse" value="false" v-model="EmailNewsletter">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <!-- :::::::::::::::::::: -->
            <!-- NOTIFICAÇÕES POR SMS -->
            <section class="small-space">
                <h3>
                    Notificações por SMS
                </h3>
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    investidor
                                </label>
                                <span class="big">
                                    Aviso de novas oportunidades
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="SmsOportunidadesTrue" value="true" v-model="SmsOportunidades">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="SmsOportunidadesFalse" value="false" v-model="SmsOportunidades">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    Repagamento
                                </label>
                                <span class="big">
                                    Notificação de repagamentos dos investimentos
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="SmsRepagamentoTrue" value="true" v-model="SmsRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="SmsRepagamentoTrue" value="false" v-model="SmsRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <!-- ::::::::::::::::::::  -->
            <!-- NOTIFICACOES POR WHATSAPP -->
            <section class="no-space">
                <h3>
                    Notificações por WhatsApp
                </h3>
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    investidor
                                </label>
                                <span class="big">
                                    Aviso de novas oportunidades
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="WhatsOportunidatesTrue" value="true" v-model="WhatsOportunidates">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="WhatsOportunidatesFalse" value="false" v-model="WhatsOportunidates">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <form class="notify">
                            <div class="form-group text-left">
                                <label for="investidor">
                                    Repagamento
                                </label>
                                <span class="big">
                                    Notificação de repagamentos dos investimentos
                                </span>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Receber
                                        <input class="form-check-input" type="radio" id="WhatsOportunidatesTrue" value="true" v-model="WhatsRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="box-radio">
                                        Não Receber
                                        <input class="form-check-input" type="radio" id="WhatsOportunidatesFalse" value="false" v-model="WhatsRepagamento">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row">
                        <div class="col-12 bts">
                            <button type="button" @click="EnviarDados" class="btn btn-primary btn-lg">
                                Atualizar
                            </button>
                        </div>
                    </div>
            </section>
            <!-- ::::::::::::::::::::::::: -->
            <!-- ::::::::::::::: -->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import * as mutationTypes from '@/store/mutation-types.js'
import ApiClient from '../utils/api-client'

export default {
        data() {
            return {
                finishedLoading: false,
                user: null,
                EmailOportunidades: true,
                EmailRepagamento: true,
                EmailNewsletter: true,
                SmsOportunidades: true,
                SaqueAutomatico: false,
                SmsRepagamento: true,
                WhatsOportunidates: true,
                WhatsRepagamento: true,
            }
        },
        methods: {
            EnviarDados() {
                console.log(this.EmailOportunidades)
                console.log(this.EmailRepagamento)
                console.log(this.EmailRepagamento)
                console.log(this.SmsOportunidades)
                console.log(this.SmsRepagamento)
                console.log(this.WhatsOportunidates)
                console.log(this.WhatsRepagamento);
                console.log(this.SaqueAutomatico);

                let options = {
                    "EmailOportunidades": this.EmailOportunidades,
                    "EmailRepagamento": this.EmailRepagamento,
                    "EmailNewsletter": this.EmailNewsletter,
                    "SmsOportunidades": this.SmsOportunidades,
                    "SmsRepagamento": this.SmsRepagamento,
                    "WhatsOportunidates": this.WhatsOportunidates,
                    "WhatsRepagamento": this.WhatsRepagamento,
                    "SaqueAutomatico": this.SaqueAutomatico,
                }

                ApiClient.userNotificationInvestor(this.user._id, options)
                .then((response) => {
                    if(response.status === 200) {
                        this.$Notify.info('Notificações atualizadas')
                    } else {
                        this.$Notify.info('Ops, Ocorreu algum problema, tente mais tarde!')
                    }
                })
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: 'perfil/configuracoes',
                    title: 'Configuracoes',
                })
            },
        }, 
        beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getUser()
            .then(response => {
                this.user = response;

                if(this.user.NotificacoesInvestidor) {
                    this.EmailOportunidades = (this.user.NotificacoesInvestidor.EmailOportunidades != null || this.user.NotificacoesInvestidor.EmailOportunidades != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.EmailRepagamento = (this.user.NotificacoesInvestidor.EmailRepagamento != null || this.user.NotificacoesInvestidor.EmailRepagamento != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.EmailNewsletter = (this.user.NotificacoesInvestidor.EmailNewsletter != null || this.user.NotificacoesInvestidor.EmailNewsletter != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.SmsOportunidades = (this.user.NotificacoesInvestidor.SmsOportunidades != null || this.user.NotificacoesInvestidor.SmsOportunidades != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.SmsRepagamento = (this.user.NotificacoesInvestidor.SmsRepagamento != null || this.user.NotificacoesInvestidor.SmsRepagamento != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.WhatsOportunidates = (this.user.NotificacoesInvestidor.WhatsOportunidates != null || this.user.NotificacoesInvestidor.WhatsOportunidates != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.WhatsRepagamento = (this.user.NotificacoesInvestidor.WhatsRepagamento != null || this.user.NotificacoesInvestidor.WhatsRepagamento != undefined) ? this.user.NotificacoesInvestidor.EmailOportunidades : true;
                    this.SaqueAutomatico = (this.user.NotificacoesInvestidor.SaqueAutomatico != null || this.user.NotificacoesInvestidor.SaqueAutomatico != undefined) ? this.user.NotificacoesInvestidor.SaqueAutomatico : false;
                }

                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
            .catch(() => {
                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        },
        async created() {
            //tagueamento GA
            await this.taggingGA();  
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/ProfileNotific.vue